"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:forbid-import */
var satcheljs_1 = require("satcheljs");
/* tslint:enable:forbid-import */
var owa_options_store_1 = require("owa-options-store");
var confirmDirtyOptionsAndPerformAction_1 = require("./confirmDirtyOptionsAndPerformAction");
exports.default = satcheljs_1.orchestratorAction('selectSubcategory', function hideFullOptions(subcategory) {
    var continueAfterConfirmCallback = function () {
        owa_options_store_1.selectSubcategory(subcategory);
    };
    confirmDirtyOptionsAndPerformAction_1.default(continueAfterConfirmCallback);
});
//# sourceMappingURL=selectSubcategory.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/orchestration/owa-options-orchestration/lib/orchestrators/selectSubcategory.js
// module id = 5283
// module chunks = 2